import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { ValidatorUtils } from '../../utils';
import { Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions } from '../../actions';
import { SwitchAccount, TitleBar, NavBar, SingleScreenNavBar, Input, Button, Errors } from  '../../components'

class PracticeLocationAddEditScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      location: {
        name: '',
        street_address: '',
        city: '',
        state: '',
        zipcode: '',
        email: '',
        phone: '',
      },
      validation: {},
    }
  }

  componentDidMount() {
    if (this.props.practice && this.props.practice.editLocationInfo) {
      const editLocationInfo = this.props.practice.editLocationInfo;
      if (editLocationInfo.type === 'edit') {
        const locInfo = editLocationInfo.location || {};
        const stateLoc = {
          name: locInfo.name || '',
          street_address: locInfo.street_address || '',
          city: locInfo.city || '',
          state: locInfo.state || '',
          zipcode: locInfo.zipcode || '',
          email: locInfo.email || '',
          phone: locInfo.phone || '',
        }
        this.setState({ ...this.state, location: stateLoc });
      }
    }
  }

  renderLocationAddEditSection = (editLocationInfo) => {

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">
        <div className="basic-container">
          <div className="flex-container flex-container-column">
            <Input  style={{ margin: 10, marginLeft: 0, width: '50%', alignSelf: 'center' }}
                    placeholder="Name"
                    value={this.state.location.name}
                    invalid={this.state.validation.fields && this.state.validation.fields['name']}
                    onChange={ (event) => {
                      this.setState({ ...this.state, location: { ...this.state.location, name: event.target.value }})
                    }}
                  />
          </div>
          <div className="flex-container flex-container-column">
            <Input  style={{ margin: 10, marginLeft: 0, width: '50%', alignSelf: 'center' }}
                    placeholder="Street Address"
                    value={this.state.location.street_address}
                    invalid={this.state.validation.fields && this.state.validation.fields['street_address']}
                    onChange={ (event) => {
                      this.setState({ ...this.state, location: { ...this.state.location, street_address: event.target.value }})
                    }}
                  />
          </div>
          <div className="flex-container flex-container-column">
            <Input  style={{ margin: 10, marginLeft: 0, width: '50%', alignSelf: 'center' }}
                    placeholder="City"
                    value={this.state.location.city}
                    invalid={this.state.validation.fields && this.state.validation.fields['city']}
                    onChange={ (event) => {
                      this.setState({ ...this.state, location: { ...this.state.location, city: event.target.value }})
                    }}
                  />
          </div>
          <div className="flex-container flex-center-justify" style={{ marginTop: 10 }}>
            <div className="flex-container flex-container-row flex-center-justify" style={{ width: '50%', marginRight: 10 }}>
              <Input  style={{ width: '70%', marginRight: 10 }}
                      placeholder="State"
                      value={this.state.location.state}
                      invalid={this.state.validation.fields && this.state.validation.fields['state']}
                      onChange={ (event) => {
                        this.setState({ ...this.state, location: { ...this.state.location, state: event.target.value }})
                      }}
                    />
              <Input  style={{ width: '30%' }}
                      placeholder="Zipcode"
                      value={this.state.location.zipcode}
                      invalid={this.state.validation.fields && this.state.validation.fields['zipcode']}
                      onChange={ (event) => {
                        this.setState({ ...this.state, location: { ...this.state.location, zipcode: event.target.value }})
                      }}
                    />
            </div>
          </div>
          { /* <div className="flex-container flex-container-column" style={{ marginTop: 10 }}>
            <input  className="input-default"
                    style={{ margin: 10, marginLeft: 0, width: '50%', alignSelf: 'center' }}
                    placeholder="Email"
                    value={this.state.location.email}
                    type="text"
                    onChange={ (event) => {
                      this.setState({ ...this.state, location: { ...this.state.location, email: event.target.value }})
                    }}
                  />
          </div>
          <div className="flex-container flex-container-column">
            <input  className="input-default"
                    style={{ margin: 10, marginLeft: 0, width: '50%', alignSelf: 'center' }}
                    placeholder="Phone"
                    value={this.state.location.phone}
                    type="text"
                    onChange={ (event) => {
                      this.setState({ ...this.state, location: { ...this.state.location, phone: event.target.value }})
                    }}
                  />
          </div> */ }
          <Errors validation={this.state.validation} />
          <div className="flex-container flex-center-justify" style={{ marginTop: 20 }}>
            <input  type="submit"
                    value="Cancel"
                    className="button-clear"
                    onClick={ () => {
                      NavigationActions.navigateBack()
                    }}
                  />
            <Button value={ editLocationInfo.type === 'new' ? 'Add Location' : 'Save' }
                    style={{ marginLeft: 5 }}
                    loading={this.props.loading && this.props.loading.createEditLocation}
                    onClick={ () => {
                      this.addEditAction(editLocationInfo);
                    }}
                  />

          </div>
        </div>

      </div>
    </div>
  }

  render() {
    const editLocationInfo = this.props.practice && this.props.practice.editLocationInfo ? this.props.practice.editLocationInfo : {};
    const screenTitle = editLocationInfo.type === 'new' ? 'Add New Location' : 'Edit Location';

    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title={screenTitle} />
        { this.renderLocationAddEditSection(editLocationInfo) }
      </div>
    );
  }

  addEditAction = (editLocationInfo) => {

    const token = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : null;
    const practiceID = this.props.context && this.props.context.selectedPractice ? this.props.context.selectedPractice : null;
    const type = editLocationInfo.type;

    var location = Object.assign({}, editLocationInfo.location);

    location.name = this.state.location.name;
    location.street_address = this.state.location.street_address;
    location.city = this.state.location.city;
    location.state = this.state.location.state;
    location.zipcode = this.state.location.zipcode;
    location.email = this.state.location.email;
    location.phone = this.state.location.phone;

    const validation = ValidatorUtils.validate('locationAddEdit', location);

    if (!validation.valid) {
      this.setState({ ...this.state, validation: validation });
      return;
    } else {
      this.setState({ ...this.state, validation: validation });
    }

    if (type === 'new' && token && practiceID) {
      location.practice_id = practiceID;
      this.props.practiceActions.addPracticeLocation(token, location, this.successAction);
    }

    if (type === 'edit' && token) {
      this.props.practiceActions.editPracticeLocation(token, location, this.successAction);
    }

  }

  successAction = () => {
    NavigationActions.navigateBack();
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    loading: state.loading,
    practice: state.practice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PracticeLocationAddEditScreen)
